import {toast} from 'react-toastify';
export default  {position: toast.POSITION.TOP_RIGHT, autoClose:3000};